<nz-layout class="summary-container">
  <nz-header class="section-header" fxLayout="column" fxLayoutAlign="center start">
    <div fxLayout="column" class="patient-name">
      <span>{{data?.patient?.firstName}} {{data?.patient?.lastName}}
        <i nz-icon nzType="icons:download" nzTheme="outline" class="download-shl-btn"
          (click)="downloadCDA()"></i></span>
    </div>

    <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px" class="patient-details mpt-5">
      <div fxLayout="column">
        @if (data?.patient?.gender) {
        <div><i nz-icon nzType="icons:gender" nzTheme="outline" class="mr-5"></i>{{data?.patient?.gender}}</div>
        }
      </div>
      <div fxLayout="column">
        @if (data?.patient?.dateOfBirth) {
        <div><i nz-icon nzType="icons:calendar-days" nzTheme="outline" class="mr-5"></i>{{data?.patient?.dateOfBirth}}
        </div>
        }
      </div>

      <div fxLayout="column">
        @if (data?.patient?.phone) {
        <div><i nz-icon nzType="icons:phone" nzTheme="outline" class="mr-5"></i>{{data?.patient?.phone}}</div>
        }
      </div>
      <div fxLayout="column">
        @if (data?.patient?.email) {
        <div><i nz-icon nzType="icons:email" nzTheme="outline" class="mr-5"></i>{{data?.patient?.email}}</div>
        }
      </div>
      <div fxLayout="column">
        @if (data?.patient?.address) {
        <div><i nz-icon nzType="icons:addressInfo" nzTheme="outline" class="mr-5"></i>{{data?.patient?.address}}</div>
        }
      </div>
    </div>


    <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px" class="patient-documents">
      @for (doc of data?.patient?.documents; track doc; let i = $index) {
      <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px" class="patient-details">
        <div fxLayout="column">
          @if (doc?.documentNumber) {
          <div>
            {{doc?.documentType}}{{doc?.documentType ? '-' :
            ''}}{{doc?.documentNumber}}{{doc?.documentCountry ? '-' : ''}}{{doc?.documentCountry}}</div>
          }
        </div>
      </div>
      }
    </div>

    <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px" class="patient-documents">
      <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px" class="patient-details">
        <div fxLayout="column">
          @if (data?.patient?.doctorFullName) {
          <div><i nz-icon nzType="icons:doctor" nzTheme="outline" class="mr-5"></i>{{data?.patient?.doctorFullName}}
          </div>
          }
        </div>
        <div fxLayout="column">
          @if (data?.patient?.hospitalName) {
          <div><i nz-icon nzType="icons:hospital" nzTheme="outline" class="mr-5"></i>{{data?.patient?.hospitalName}}
          </div>
          }
        </div>
      </div>

      <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px" class="patient-details">
        <div fxLayout="column">
          @if (data?.patient?.hospitalPhoneNumber) {
          <div><i nz-icon nzType="icons:phone" nzTheme="outline" class="mr-5"></i>{{data?.patient?.hospitalPhoneNumber}}
          </div>
          }
        </div>
        <div fxLayout="column">
          @if (data?.patient?.hospitalEmail) {
          <div><i nz-icon nzType="icons:email" nzTheme="outline" class="mr-5"></i>{{data?.patient?.hospitalEmail}}</div>
          }
        </div>
      </div>
    </div>
  </nz-header>
  <nz-content class="summary-body">

    <!-- ALLERGIES -->
    <app-custom-table title="Allergies" [data]="data?.allergies?.getAll" [dataGetList]="data?.allergies"
      [isLoading]="isLoading" [isPreview]="false">
      @for (allergy of data?.allergies?.getAll; track allergy) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="info" fxLayout="column" fxLayoutAlign="center start">
              <div fxLayout="column" class="title">
                <span>{{allergy.name}}</span>
              </div>
              <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
                @if (allergy?.effectiveLow) {
                <div fxLayout="column">
                  <div><span class="f-500">{{"Resolution Date"|translate}}: </span>
                    {{this.formatDate(allergy.effectiveLow)}}</div>
                </div>
                }
                <div fxLayout="column">
                  <div><span class="f-500">{{"Code"|translate}}: </span>{{allergy.code}}</div>
                </div>
                <div fxLayout="column">
                  <div><span class="f-500">{{"Code System"|translate}}:
                    </span>{{allergy.codeSystem}}</div>
                </div>
                <div fxLayout="column">
                  <div><span class="f-500">{{"Status"|translate}}:
                    </span>{{allergy.status}}</div>
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (allergy?.getAllReactions?.length == 0 || !allergy?.getAllReactions) {
        <div>
          <div class="info" fxLayout="column" fxLayoutAlign="center start">
            {{"No reactions listed." | translate}}
          </div>
        </div>
        }
        @for (reaction of allergy?.getAllReactions; track reaction; let i = $index) {
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{i + 1}}. {{reaction.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Start Date"|translate}}: </span>
                {{this.formatDate(reaction.effectiveLow)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"End Date"|translate}}: </span>
                {{this.formatDate(reaction.effectiveHigh)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{reaction.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{reaction.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{reaction.status}}</div>
            </div>
          </div>
        </div>
        }
      </mat-expansion-panel>
      }
    </app-custom-table>

    <!-- CARE PLANS -->
    @if (data?.carePlans?.length) {
    <app-custom-table title="Care Plans" [data]="data?.carePlans" [isLoading]="isLoading" [isPreview]="false">
      @for (cp of data?.carePlans; track cp; let carePlanIndex = $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="info" fxLayout="column" fxLayoutAlign="center start">
              <div class="title">{{carePlanTitle(cp, carePlanIndex)}}</div>
              <div class="detail-summary">{{carePlanSubtitle(cp, carePlanIndex)}}</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="clinical-sections">
          @for (section of carePlanSections(cp, carePlanIndex); track section.title) {
          <section class="clinical-section">
            <h4>{{section.title | translate}}</h4>
            @if (section.text) {
            <p class="section-narrative">{{section.text}}</p>
            }
            @for (row of section.rows; track $index) {
            <div class="detail-row">
              <span class="f-500">{{row.title | translate}}:</span>
              <span>{{row.detail}}</span>
            </div>
            }
          </section>
          }
        </div>
      </mat-expansion-panel>
      }
    </app-custom-table>
    }

    <!-- ISSUED DISCHARGE REPORTS -->
    @if (data?.dischargeReports?.length) {
    <app-custom-table title="Issued Discharge Reports" [data]="data?.dischargeReports" [isLoading]="isLoading"
      [isPreview]="false">
      @for (report of data?.dischargeReports; track report) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="info" fxLayout="column" fxLayoutAlign="center start">
              <div fxLayout="column" class="title">
                <span>{{valueOrFallback(report.header.documentTitle)}}</span>
              </div>
              <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
                <div fxLayout="column">
                  <div><span class="f-500">{{"Report Identifier"|translate}}: </span>{{reportIdentifier(report)}}</div>
                </div>
                <div fxLayout="column">
                  <div><span class="f-500">{{"Status"|translate}}: </span>{{codeableConceptText(report.header.status)}}</div>
                </div>
                <div fxLayout="column">
                  <div><span class="f-500">{{"Issued Date"|translate}}: </span>{{formatReportDate(report.header.date)}}</div>
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="clinical-sections">
          @for (section of dischargeReportSections(report); track section.title) {
          <section class="clinical-section">
            <h4>{{section.title | translate}}</h4>
            @if (section.text) {
            <p class="section-narrative">{{section.text}}</p>
            }
            @for (row of section.rows; track $index) {
            <div class="detail-row">
              <span class="f-500">{{row.title | translate}}:</span>
              <span>{{row.detail}}</span>
            </div>
            }
          </section>
          }
        </div>
      </mat-expansion-panel>
      }
    </app-custom-table>
    }

    <!-- PROBLEMS -->
    <app-custom-table title="Problems" [data]="data?.problems?.getAll" [dataGetList]="data?.problems"
      [isLoading]="isLoading" [isPreview]="false">
      @for (problem of data?.problems?.getAll; track problem) {
      <div class="entry-container">
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{problem.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Date"|translate}}: </span>
                {{this.formatDate(problem.effectiveLow)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{problem.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{problem.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{problem.status}}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </app-custom-table>

    <!-- PROCEDURES -->
    <app-custom-table title="Procedures" [data]="data?.procedures?.getAll" [dataGetList]="data?.procedures"
      [isLoading]="isLoading" [isPreview]="false">
      @for (procedure of data?.procedures?.getAll; track procedure) {
      <div class="entry-container">
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{procedure.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Date"|translate}}: </span>
                {{this.formatDate(procedure.effectiveLow)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{procedure.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{procedure.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{procedure.status}}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </app-custom-table>

    <!-- MEDICATIONS -->
    <app-custom-table title="Medications" [data]="data?.medications?.getAll" [dataGetList]="data?.medications"
      [isLoading]="isLoading" [isPreview]="false">
      @for (medication of data?.medications?.getAll; track medication) {
      <div class="entry-container">
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{medication.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Date"|translate}}: </span>
                {{this.formatDate(medication.effectiveLow)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{medication.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{medication.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{medication.status}}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </app-custom-table>

    <!-- MEDICAL DEVICES -->
    <app-custom-table title="Medical Devices" [data]="data?.medicalDevices?.getAll" [dataGetList]="data?.medicalDevices"
      [isLoading]="isLoading" [isPreview]="false">
      @for (md of data?.medicalDevices?.getAll; track md) {
      <div class="entry-container">
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{md.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Date"|translate}}: </span>
                {{this.formatDate(md.effectiveLow)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{md.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{md.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{md.status}}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </app-custom-table>

    <!-- SOCIAL HISTORY -->
    <app-custom-table title="Social History" [data]="data?.socialHistory" [isLoading]="isLoading" [isPreview]="false">
      @for (sh of data?.socialHistory; track sh) {
      <div class=" entry-container">
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{sh.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Date"|translate}}: </span>
                {{this.formatDate(sh.effectiveLow)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{sh.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{sh.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{sh.status}}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </app-custom-table>

    <!-- VACCINATIONS -->
    <app-custom-table title="Vaccinations" [data]="data?.vaccinations?.getAll" [dataGetList]="data?.vaccinations"
      [isLoading]="isLoading" [isPreview]="false">
      @for (vaccination of data?.vaccinations?.getAll; track vaccination) {
      <div class="entry-container">
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{vaccination.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Date"|translate}}: </span>
                {{this.formatDate(vaccination.effectiveLow)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{vaccination.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{vaccination.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{vaccination.status}}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </app-custom-table>

    <!-- PREGNANCY STATUS -->
    @if (data?.pregnancyModels?.statusData) {
    <app-custom-table title="Pregnancy Status" [data]="data?.pregnancyModels?.statusData" [isLoading]="isLoading"
      [isPreview]="false">
      @for (ps of data?.pregnancyModels?.statusData; track ps) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="info" fxLayout="column" fxLayoutAlign="center start">
              <div fxLayout="column" class="title">
                <span>{{ps.name}}</span>
              </div>
              <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
                <div fxLayout="column">
                  <div><span class="f-500">{{"Date"|translate}}: </span>
                    {{this.formatDate(ps.date)}}</div>
                </div>
                <div fxLayout="column">
                  <div><span class="f-500">{{"Code"|translate}}: </span>{{ps.code}}</div>
                </div>
                <div fxLayout="column">
                  <div><span class="f-500">{{"Code System"|translate}}:
                    </span>{{ps.codeSystem}}</div>
                </div>
                <div fxLayout="column">
                  <div><span class="f-500">{{"Status"|translate}}:
                    </span>{{ps.status}}</div>
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{ps.pregnancyStatusEntryRealtionship.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Date"|translate}}: </span>
                {{this.formatDate(ps.pregnancyStatusEntryRealtionship.date)}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}:
                </span>{{ps.pregnancyStatusEntryRealtionship.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{ps.pregnancyStatusEntryRealtionship.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{ps.pregnancyStatusEntryRealtionship.status}}</div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      }
    </app-custom-table>
    }

    <!-- PREGNANCY OUTCOME -->
    @if (data?.pregnancyModels?.outcomeData) {
    <app-custom-table title="Pregnancy Outcome" [data]="data?.pregnancyModels?.outcomeData" [isLoading]="isLoading"
      [isPreview]="false">
      @for (po of data?.pregnancyModels?.outcomeData; track po) {
      <div class="entry-container">
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{po.name}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Value"|translate}}: </span>
                {{po.value}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{po.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{po.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{po.status}}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </app-custom-table>
    }

    <!-- PREGNANCY HISTORY -->
    @if (data?.pregnancyModels?.historyData) {
    <app-custom-table title="Pregnancy History" [data]="data?.pregnancyModels?.historyData" [isLoading]="isLoading"
      [isPreview]="false">
      @for (ph of data?.pregnancyModels?.historyData; track ph) {
      <div class="entry-container">
        <div class="info" fxLayout="column" fxLayoutAlign="center start">
          <div fxLayout="column" class="title">
            <span>{{ph.code}}</span>
          </div>
          <div fxLayout="column" fxLayout="start center" fxLayoutGap="15px">
            <div fxLayout="column">
              <div><span class="f-500">{{"Value"|translate}}: </span>
                {{ph.value}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code"|translate}}: </span>{{ph.code}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Code System"|translate}}:
                </span>{{ph.codeSystem}}</div>
            </div>
            <div fxLayout="column">
              <div><span class="f-500">{{"Status"|translate}}:
                </span>{{ph.status}}</div>
            </div>
          </div>
        </div>
      </div>
      }
    </app-custom-table>
    }

  </nz-content>
</nz-layout>

<nz-modal #modalRef nzSize [(nzVisible)]="isVisible" [nzTitle]="'Demographics' | translate"
  (nzOnCancel)="handleCancel()" nzOkType="primary" [nzFooter]="null">

</nz-modal>
